const defaultOptions = {
    headers: {
        "Content-Type": "application/json",
    },
};

export const request = async (url: string, options: object) => {
    const response = await fetch(url, options);
    const contentType = response.headers.get("content-type");
    let data;
    if (contentType && contentType.indexOf("application/json") !== -1) {
        const body = await response.text();
        data = body ? JSON.parse(body) : {};
    } else {
        data = await response.text();
    }
    return {
        data,
        ok: response.ok,
        status: response.status,
    };
};

export default {
    GET: (url: string, options = {}) =>
        request(url, {
            method: "GET",
            cache: "force-cache",
            ...defaultOptions,
            ...options,
        }),
    POST: (url: string, body = {}, options = {}) =>
        request(url, {
            method: "POST",
            body: JSON.stringify(body),
            ...defaultOptions,
            ...options,
        }),
    PUT: (url: string, body = {}, options = {}) =>
        request(url, {
            method: "PUT",
            body: JSON.stringify(body),
            ...defaultOptions,
            ...options,
        }),
    DELETE: (url: string, options = {}) =>
        request(url, {
            method: "DELETE",
            ...defaultOptions,
            ...options,
        }),
};



// WEBPACK FOOTER //
// ./src/constants/Request.ts